module.exports = __webpack_public_path__ + "img/1.94978027.png";